<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/productapproval' }">产品批文</el-breadcrumb-item>
                <el-breadcrumb-item>{{ headerTitle }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="addNews">新增</el-button>
                    <el-button size="small" plain @click="copy">复制</el-button>
                    <el-button size="small" plain @click="editDetails">编辑</el-button>
                    <el-button size="small" plain @click="amend(list.id)">删除</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form label-position="right" :model="list" class="details" label-width="auto">
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="code：">
                                    <el-input v-model="list.code" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="批准文号：">
                                    <el-input
                                        v-model="list.licence_number"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="产品通用名：">
                                    <el-input
                                        v-model="list.product_common_name"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input> </el-form-item
                            ></el-col>

                            <el-col :span="12">
                                <el-form-item label="产品批文：">
                                    <el-input
                                        v-model="list.licence_product_name"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input> </el-form-item
                            ></el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="含量规格：">
                                    <el-input v-model="list.content_spec" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="有效期(月)：">
                                    <el-input
                                        v-model="list.validity_months"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input> </el-form-item
                            ></el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="含量规格单位：">
                                    <el-input v-model="list.content_un" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="有效期(天)：">
                                    <el-input
                                        v-model="list.validity_days"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input> </el-form-item
                            ></el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="包装规格单位：">
                                    <el-input
                                        v-model="list.dosage_un"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input> </el-form-item
                            ></el-col>
                            <el-col :span="12">
                                <el-form-item label="生产企业：">
                                    <div class="read_only read_only_link">
                                        <span @click="entrustClick(list.manufacturer_rid)">{{ list.manufacturer_name }}</span>
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="治疗领域：">
                                    <el-input
                                        v-model="list.product_therapeutic_area_rids"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input> </el-form-item
                            ></el-col>
                            <el-col :span="12">
                                <el-form-item label="产品剂型：">
                                    <el-input
                                        v-model="list.product_formulation"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="创建人：" prop="created_by">
                                    <div class="read_only">{{ list.created_by ? list.created_by : '' }}</div></el-form-item
                                ></el-col
                            >
                            <el-col :span="12">
                                <el-form-item label="上次修改人：" prop="updated_by">
                                    <div class="read_only">{{ list.updated_by ? list.updated_by : '' }}</div></el-form-item
                                ></el-col
                            >
                            <el-col :span="12"> </el-col>
                        </el-row>
                    </el-form>
                </el-collapse-item>
                <el-collapse-item disabled title="产品" name="2">
                    <vProductComponent :postList="postList" v-if="flag"></vProductComponent>
                </el-collapse-item>

                <el-collapse-item disabled title="产品批文期间" name="3">
                    <vProductLicencePeriodComponent v-if="flag" :postList="postList3"></vProductLicencePeriodComponent>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import vProductComponent from '../../listComponent/basicdata/product/productComponent.vue';
import vProductLicencePeriodComponent from '@/components/page/listComponent/basicdata/product/productLicencePeriodComponent.vue';
export default {
    inject: ['reload'],
    name: 'productDetails',
    components: {
        vProductComponent,
        vProductLicencePeriodComponent
    },
    data() {
        return {
            list: {}, //产品批文详情
            activeNames: ['1', '2', '3'],
            rid: '',
            headerTitle: '产品批文详情',
            postList: {
                headerTitle: false,
                code: false,
                name: false,
                licence_number: false,
                product_common_name: false,
                licence_product_name: false,
                addBtn: true,
                searchBtn: false,
                resetBtn: false,
                downFileBtn: false,
                setBtn: true,
                params: {
                    product_licence_rid: '',
                    product_common_name: ''
                }
            },
            postList3: {
                product_licence_rid: false,
                params: {
                    product_licence_rid: ''
                }
            },
            flag: false
        };
    },
    watch: {
        $route(to, from) {
            this.rid = to.query.id;
            this.reload();
        }
    },
    mounted() {
        this.rid = this.$route.query.id;
        this.postList.params.product_licence_rid = this.$route.query.id;
        this.postList3.params.product_licence_rid = this.$route.query.id;
        this.getDetails(); //获取详情
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {
        //删除
        amend(id) {
            var params = {
                id: id
            };
            let messages = '此操作将删除此条数据，是否继续?';
            this.$msgbox({
                title: '消息',
                message: messages,
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                closeOnPressEscape: false,
                closeOnClickModal: false,
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        instance.confirmButtonText = '删除...';
                        this.$api
                            .productLicenceDelete(params)
                            .then((res) => {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                                if (res.code == 0) {
                                    this.$message({
                                        showClose: true,
                                        message: '删除成功',
                                        type: 'success'
                                    });
                                    this.$bus.$emit('fullPath', this.$route.fullPath);
                                    this.$router.push({
                                        path: '/productapproval'
                                    });
                                }
                            })
                            .catch((error) => {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                            });
                    } else {
                        done();
                    }
                }
            })
                .then((action) => action)
                .catch((error) => error);
        },
        //复制页面
        copy() {
            this.$router.push({
                path: 'productedit',
                query: {
                    type: 5,
                    id: this.rid
                }
            });
        },
        //前往编辑页面
        editDetails() {
            this.$router.push({
                path: 'productedit',
                query: {
                    type: 1,
                    id: this.rid
                }
            });
        },
        //新增
        addNews() {
            this.$router.push({
                path: 'productedit',
                query: {
                    type: 3,
                    id: this.rid
                }
            });
        },
        //取消
        cancel() {
            if (window.history.length <= 1) {
                this.$router.push({ path: '/productApproval' });
            } else {
                this.$router.go(-1);
            }
        },
        //产品批文详情
        getDetails() {
            let params = {
                rid: this.rid
            };
            this.$api
                .productLicenceDetail(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.list = res.data;
                        document.title = this.headerTitle + ':' + res.data.code;
                        this.postList.params.product_common_name = res.data.product_common_name;
                    }
                })
                .catch((error) => {});
        },
        //受托生产企业
        entrustClick(rid) {
            this.$router.push({
                path: 'accountDetails',
                query: {
                    id: rid
                }
            });
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
.el-collapse {
    /deep/ .el-table__empty-block {
        width: 100% !important;
        min-width: 100% !important;
        max-width: 100% !important;
        padding-right: 100% !important;
    }
}
</style>